(() => {
  function init(root = document) {
    root.querySelectorAll('.wr-product-widget').forEach(widget => {
      if (widget.dataset.initialized) return;
      widget.dataset.initialized = 'true';
      const form = widget.querySelector('form');
      if (!form) return;
      const input = form.querySelector('[data-variant-input]');
      const button = form.querySelector('.wr-add-btn');
      const error = form.querySelector('[data-cart-error]');
      const variants = [...widget.querySelectorAll('.wr-variant-btn')];
      let busy = false;
      let available = !button.disabled;
      const refresh = () => {
        button.disabled = busy || !available;
        button.setAttribute('aria-disabled', String(button.disabled));
        const label = available ? button.dataset.labelAdd : button.dataset.labelSold;
        button.querySelector('[data-btn-text]').textContent = label;
        button.setAttribute('aria-label', label);
      };
      variants.forEach(variant => variant.addEventListener('click', () => {
        if (busy) return;
        variants.forEach(v => {v.classList.toggle('is-selected',v === variant);v.setAttribute('aria-pressed',String(v === variant));});
        input.value = variant.dataset.variantId;
        widget.querySelector('[data-price]').textContent = variant.dataset.variantPrice;
        available = variant.dataset.variantAvailable === 'true';
        refresh();
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !available || !input.value) return;
        busy = true; refresh();
        variants.forEach(v => v.disabled = true);
        button.setAttribute('aria-busy','true');
        error.hidden = true;
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const localeRoot = window.Shopify?.routes?.root || '/';
        try {
          const body = new FormData(form);
          if (cart?.getSectionsToRender) {
            body.append('sections',cart.getSectionsToRender().map(s => s.id).join(','));
            body.append('sections_url',location.pathname);
            cart.setActiveElement?.(document.activeElement);
          }
          const response = await fetch(window.routes?.cart_add_url || localeRoot+'cart/add.js', {method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body});
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || error.dataset.fallback);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate,{source:'wild-rose-product',productVariantId:input.value,cartData:data});
          }
          if (cart?.renderContents && cart.getSectionsToRender().every(s => data.sections?.[s.id])) {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            location.assign(window.routes?.cart_url || localeRoot+'cart');
          }
        } catch (err) {
          error.textContent = err.message || error.dataset.fallback;
          error.hidden = false;
        } finally {
          busy = false; refresh();
          variants.forEach(v => v.disabled = false);
          button.removeAttribute('aria-busy');
        }
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
